<template>
    <div>
        <delivery-form :entity-id="entityId"></delivery-form>
    </div>
</template>

<script>
import deliveryForm from '@/components/pages/deliveries/CreateNewProviderJobForm'
import dirtyForm from '@/components/mixins/dirtyForm'

export default {
    components: { deliveryForm },

    mixins: [dirtyForm],

    data() {
        return {
            entityId: null,
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler(route) {
                this.entityId = route.params.id
            },
        },
    },
}
</script>
